export { default } from './BrandsLogoList';
